import Title from '../../microComponents/elements/Title';
import ComponentCard from '../../microComponents/elements/ComponentCard';
import {Button, DatePicker, Form, Input, Select} from "antd";
import React, {useEffect, useState} from "react";
import GetProductList from "../Products/GetProductList";
import Pallet from "../../http_request/Model/pallet/Pallet";
import ResultComponent from "../../microComponents/modals/ResultComponent";
import Preview from "../../microComponents/elements/Preview";
import {getFilterBranch} from "../../microComponents/tablePages/getFilterBranch";
import locale from "antd/es/date-picker/locale/fa_IR";

const {TextArea} = Input;


const PalletIdStore = () => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [productList, setProductList] = useState([]);
    const [productListLoading, setProductListLoading] = useState(false);
    const [code, setCode] = useState();
    const [openResult, setOpenResult] = useState(false);
    const [branchLoading, setBranchLoading] = useState(false);
    const [filterBranch, setFilterBranch] = useState([]);
    const [data, setData] = useState({});

    const onFinishFailed = () => {
        setShowModal(false)
    };


    const onFinish = (values) => {
        setShowModal(true)


    };

    const handleSubmit = () => {
        const values = form.getFieldsValue()
        Pallet.request({
            beforeSend: () => {
                setLoading(true)
                setShowModal(false)
                form.resetFields()
            }, success: (result) => {
                setCode(result)
                setOpenResult(true)
            }, final: () => {
                setLoading(false)
            }


        }).createWarehouse(values)
    };


    useEffect(() => {

        GetProductList(setProductList, setProductListLoading)
        getFilterBranch(setFilterBranch, setBranchLoading)

    }, []);


    return (<div>
            <ComponentCard>
                <div className='flex justify-between'>
                    <Title>صدور شناسه انبار</Title>

                </div>
            </ComponentCard> <ComponentCard>
            <ResultComponent openResult={openResult} setOpenResult={setOpenResult}
                             status="success"
                             title={`کد تایید: ${code}`}
                             extra={[

                                 <Button key="buy" onClick={() => {
                                     setOpenResult(false)
                                 }}>بستن</Button>,
                             ]}

            />
            <Form
                form={form}
                name="basic"
                layout='vertical'
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
            >


                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">

                    <Form.Item
                        name="branchId"
                        label="واحد"
                        rules={[{
                            required: true, message: 'لطفا واحد را وارد کنید!',
                        },]}

                    >
                        <Select showSearch
                                onChange={(e,x)=>{
                                    setData({...data,branchId : x})
                                }}
                                loading={branchLoading}
                                filterOption={(input, option) => {
                                    return (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())
                                }}

                                options={filterBranch}/>
                    </Form.Item>
                    <Form.Item
                        name="product"
                        label="محصول"
                        rules={[{
                            required: true, message: 'لطفا محصول را وارد کنید!',
                        },]}
                    >


                        <Select showSearch
                                filterOption={(input, option) => {
                                    return (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())
                                }}


                                onChange={(e, x) => {
                                    form.setFieldValue('numberPerPallet', x.numberPerPallet)

                                    setData({...data,product : x})


                                }}



                                loading={productListLoading}
                                options={productList}/>
                    </Form.Item>
                    <Form.Item
                        name="dateOfManufacture"
                        label="تاریخ تولید"
                        rules={[{
                            required: true, message: 'لطفا تاریخ تولید را وارد کنید!',
                        },]}
                    >

                        <DatePicker  locale={{
                            ...locale,
                            lang: {
                                ...locale.lang,
                                ok: "تایید",
                            }
                        }}

                                     className='w-full' popupClassName='datePickerBtn'

                                    onChange={(e,x)=>{
                                         setData({...data,dateOfManufacture : x})

                                    }}


                                    showTime={{format: 'HH:mm'}}
                                    format="YYYY-MM-DD HH:mm"
                                    placeholder={['تاریخ تولید']}


                        />
                    </Form.Item>


                    <Form.Item
                        name="numberPerPallet"
                        label="تعداد در پالت"
                        rules={[{
                            required: true, message: 'لطفا تعداد در پالت را وارد کنید!',
                        },]}

                    >
                        <Input   onChange={(e)=>{
                            setData({...data,numberPerPallet : e.target.value})

                        }}/>
                    </Form.Item>
                    <Form.Item
                        name="requiredNumber"
                        label="تعداد چاپ"
                        rules={[{
                            required: true, message: 'لطفا تعداد چاپ را وارد کنید!',
                        },
                            {
                                message: 'حداکثر تعداد 50 عدد می باشد.',
                                validator: (_, value) => {
                                    if (value > 0 && value <= 50) {
                                        return Promise.resolve();
                                    } else {
                                        return Promise.reject('حداکثر تعداد 50 عدد می باشد.');
                                    }
                                }
                            }


                        ]}

                    >
                        <Input type='number'  onChange={(e)=>{
                            setData({...data,requiredNumber : e.target.value})

                        }}/>
                    </Form.Item>
                    <Form.Item


                        name="description"
                        label="توضیحات"

                    >
                        <TextArea row={4}/>

                    </Form.Item>

                </div>
                <div className="flex justify-end">
                    <Preview data={data} loading={loading} handleCheckValidate={() => {
                        form.submit()
                    }}
                             handleSubmit={handleSubmit}
                             setShowModal={setShowModal} showModalStatus={showModal} getData={() => {
                        return form.getFieldsValue()
                    }}/>
                </div>


            </Form>


        </ComponentCard></div>
    );
};


export default PalletIdStore;